/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import FormulaCard from "../common_field/FormulaCard";
import useLanguage from "../common_hooks/useLanguage";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_MO = ({
  //variable
  // auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const { language, dict } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { formula, decimal_digits } = field_editable || {};
  const { geo_layer_list, layer_id } = layer;

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;

  // filter fields based on parent_uuid (supaya cuma nampilin field di level yg sama)
  const fields = geo_layer?.fields.filter((field) => {
    if (field_editable?.parent_uuid) {
      return field?.parent_uuid === field_editable?.parent_uuid
    } else {
      return !field?.parent_uuid
    }
  }) || [];

  //functions
  const handleFormula = (value) => {
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        formula: value,
      },
    });
  };

  const handleDecimalInput = (e) => {
    if (
      /[0-9]/.test(e.nativeEvent.data) ||
      e.nativeEvent.inputType === "deleteContentBackward"
    ) {
      set_value_properties({
        key: "field_editable",
        value: {
          ...field_editable,
          decimal_digits: e.target.value,
        },
      });
    }
  };

  // console.log("field_editable=", field_editable);
  // console.log("fields=", fields);

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Math Operator</h1>

      <div className="container background_grey_light outline_grey paddingTop_10 marginBottom_15">
        <FormulaCard
          formula={formula}
          fields={fields}
          handleFormula={handleFormula}
        />
        <div>
          <label className="font_18 w_full">
            {dict?.["Decimal"]?.[language]}
          </label>
          <div>
            <label className="w_full">
              {
                dict?.[
                "Decimal (number of digits after the decimal point)"
                ]?.[language]
              }
            </label>
            <div>
              <label>Places:</label>
              <input
                type="number"
                required={true}
                onChange={handleDecimalInput}
                value={decimal_digits}
                min={0}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  // auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_MO);
